/* One-time VIDEO intro. Plays once per session; skippable via the button,
   click/tap, or Esc; no-op under reduced-motion. Autoplay-blocked / missing /
   errored video → show the poster briefly then dismiss (never trap the user on
   a frozen frame). Deferred so it never blocks content — the Home page is live
   underneath and the overlay is already covered by the poster from HTML. */
(function () {
  'use strict';
  var overlay = document.querySelector('[data-lmp-intro]');
  if (!overlay) return;
  var html = document.documentElement;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var seen; try { seen = sessionStorage.getItem('lmp-intro-seen'); } catch (e) { seen = '1'; }

  function remove() { if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay); }

  // Repeat visit or reduced-motion → never play; show the page immediately.
  if (reduce || seen || html.classList.contains('lmp-nointro')) { remove(); return; }

  var video = overlay.querySelector('[data-lmp-intro-video]');
  var done = false, fallbackTimer, capTimer;

  function end(instant) {
    if (done) return; done = true;
    clearTimeout(fallbackTimer); clearTimeout(capTimer);
    try { sessionStorage.setItem('lmp-intro-seen', '1'); } catch (e) {}
    try { if (video) video.pause(); } catch (e) {}
    try { window.scrollTo(0, 0); } catch (e) {} /* reveal at the top so the header/menu is in view */
    html.classList.add('lmp-intro-revealing');
    if (instant) { remove(); return; }
    overlay.classList.add('is-fading');            // ~400ms fade (see CSS)
    var removed = false;
    overlay.addEventListener('transitionend', function () { removed = true; remove(); }, { once: true });
    setTimeout(function () { if (!removed) remove(); }, 700); // fallback if transitionend never fires
  }
  function skip() { end(true); }

  // Autoplay-blocked / no source / decode error → hold the poster ~1.2s, dismiss.
  function posterFallback() {
    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(function () { end(false); }, 1200);
  }

  if (video) {
    video.addEventListener('ended', function () { end(false); });
    video.addEventListener('error', posterFallback);
    // Try to autoplay (muted + playsinline are set in HTML for mobile/iOS).
    var p;
    try { p = video.play(); } catch (e) { p = null; }
    if (p && typeof p.catch === 'function') { p.catch(posterFallback); }
    // Safety net: never trap the user even if 'ended' never fires (stall/loop).
    capTimer = setTimeout(function () { end(false); }, 6000);
  } else {
    posterFallback();
  }

  var btn = overlay.querySelector('[data-lmp-intro-skip]');
  if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); skip(); });
  overlay.addEventListener('click', skip);
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') skip(); });
})();
